export const picklistTemplateIntegers = [];
export const picklistTemplateFloats = [];
export const picklistTemplateIsoStrings = [];
export const picklistTemplateWhiteList = ['id', 'name'];
export const picklistTemplateOptimisticList = [
  ...picklistTemplateWhiteList,
  'picklists',
  'picklistTemplateProducts',
];
